@if ((loading$ | async) === false) {
  <p-card>
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Контрагент</label>
        <crm-contragent-single-select
          [selectedEntity]="salaryAccrual.contragent"
          [onlyWithSalaryControl]="true"
          [isNotAutoSelect]="true"
          [isError]="!!errors?.contragent"
          (selectedEntityChange)="onContragentChange($event)"
          appendTo="body"></crm-contragent-single-select>
        @if (errors?.contragent) {
          <small class="p-error">
            {{ errors.contragent | join }}
          </small>
        }
      </div>

      <div class="field">
        <label class="font-medium required-field">Месяц расчёта</label>
        <crm-datepicker
          [(value)]="salaryAccrual.period"
          view="month"
          [inputStyleClass]="errors?.period ? 'ng-invalid ng-dirty' : ''"
          appendTo="body"></crm-datepicker>
        @if (errors?.period) {
          <small class="p-error">
            {{ errors.period | join }}
          </small>
        }
      </div>

      <div class="field">
        <label class="font-medium required-field">Сумма ЗП</label>
        <p-inputNumber
          [(ngModel)]="salaryAccrual.amount"
          [min]="0"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          mode="decimal"
          locale="ru-RU"
          [inputStyleClass]="errors?.amount ? 'ng-invalid ng-dirty' : ''"></p-inputNumber>
        @if (errors?.amount) {
          <small class="p-error">
            {{ errors.amount | join }}
          </small>
        }
      </div>
    </div>
  </p-card>

  @if ((form$ | async)?.canWrite) {
    <div class="mt-3">
      <div class="flex flex-wrap justify-content-between">
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success"
          (onClick)="saveSalaryAccrual()"></crm-button>
        @if ((form$ | async)?.isShowDelete) {
          <crm-button
            label="Удалить"
            styleClass="p-button-danger p-button-text"
            (onClick)="deleteSalaryAccrual()"></crm-button>
        }
      </div>
    </div>
  }
} @else {
  <crm-spinner></crm-spinner>
}
